<div class="container-small backdrop hilCase-modal" style="overflow: hidden">
  <div class="case-details-modal-header">
    <h1 mat-dialog-title>
      {{ "AuditLogDate.Title" | translate }}
    </h1>
  </div>
  <div class="mat-dialog-content-al">
    <div class="modal-body">
      <div class="row">
        <button class="btn filter-dates" [ngClass]="[ showStartDate ? 'filter-dates-focus' : '']" (click)="toggle('startDate')">
          {{ "AuditLogDate.StartDate" | translate }}
        </button>
        <button class="btn filter-dates" [ngClass]="[ showEndDate ? 'filter-dates-focus' : '']" (click)="toggle('endDate')">
          {{ "AuditLogDate.EndDate" | translate }}
        </button>
      </div>
      <div class="edd-d-flex">
        <div *ngIf="showStartDate">
          <mat-card appearance="outlined" class="demo-inline-calendar-card">
            <mat-calendar [maxDate]="maxDate" [startAt]="selectedStart" [(selected)]="selectedStart"
              (click)="dateChosen($event, 'startDate')">
            </mat-calendar>
          </mat-card>
        </div>
        <div *ngIf="showEndDate">
          <mat-card appearance="outlined" class="demo-inline-calendar-card">
            <mat-calendar [maxDate]="today" [startAt]="selectedEnd" [minDate]="minDate" [(selected)]="selectedEnd"
              (click)="dateChosen($event, 'endDate')"></mat-calendar>
          </mat-card>
        </div>
        <div class="edd-right-bar">
          <p>
            {{ "AuditLogDate.LSDate" | translate }}
          </p>
          <div class="dis-date">
            <span class="btn active-date" *ngIf="selectedStart" (click)="toggle('startDate')">{{ selectedStart | date:
              "MM/dd/yyyy" }}</span>
          </div>
          <p>
            {{ "AuditLogDate.LEDate" | translate }}
          </p>
          <div class="dis-date">
            <span class="btn active-date" *ngIf="selectedEnd" (click)="toggle('endDate')">{{ selectedEnd | date:
              "MM/dd/yyyy" }}</span>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button class="cancelbtn" (click)="onCancel()">
          {{ "AuditLogDate.Cancel" | translate }}
        </button>
        <button class="my-active show-more-button btn-SN-primary" (click)="download()" [disabled]="!isDisabled">
          {{ "AuditLogDate.Submit" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>